// extracted by mini-css-extract-plugin
export default {"container":"MiddleEllipsisText_container__bV0L8"};